(function() { window.GUID_94c85d58_15d8_472c_92a8_af8db445b0d0 = { getGuid: function() { return "94c85d58-15d8-472c-92a8-af8db445b0d0"; } }; })();
//namespace CS.Controls {
//    export class Link {
//        ///Appeler dans _smart-mapper.cshtml
//        public static HandleAnchorsClick() {
//            CS.DOM.$body.offon('click.a', 'a:not(.external,.ui-state-disabled)', function (e) {
//                e.preventDefault();
//                let href = $(this).attr('href'); 
//                if (href == "#") {
//                    return;
//                }
//                CS.Nav.Go(href);
//            });
//        }
//    }
//}

//# sourceMappingURL=link.js.map
